/**
 *
 * @param {Element} element
 * @returns {Position} Position relative to parent element
 */
export function getCenterFromElement(element) {
  if (!element || !element.parentElement) {
    
    return { x: 0, y: 0 };
  }

  const parent = element.parentElement.getBoundingClientRect();
  const rect = element.getBoundingClientRect();

  if (!rect || !parent || 
      !isFinite(rect.x) || !isFinite(rect.y) || 
      !isFinite(rect.width) || !isFinite(rect.height) ||
      !isFinite(parent.x) || !isFinite(parent.y)) {
    
    return { x: 0, y: 0 };
  }

  const centerX = rect.x + rect.width / 2 - parent.x;
  const centerY = rect.y + rect.height / 2 - parent.y;

  if (!isFinite(centerX) || !isFinite(centerY)) {
    
    return { x: 0, y: 0 };
  }

  return {
    x: centerX,
    y: centerY,
  };
}
